"use strict";

document.addEventListener( 'DOMContentLoaded', function () {

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header, buttons and aside
    // *
    // *

    // Selecting DOM elements
    const menuBtn = document.querySelector(".js-menu-btn");
    const aside = document.querySelector(".js-menu");
    const menuclose = document.querySelector(".js-menu-close");
    const header = document.querySelector(".js-header");
    const body = document.body;
    const html = document.documentElement;

    // Event handler for clicking the menu button
    if (menuBtn !== null) {
        menuBtn.onclick = function(e) {
            e.preventDefault();
            aside.classList.toggle("open");
            header.classList.toggle("open");
            body.classList.toggle("no-scroll");
            html.classList.toggle("no-scroll");
        }
    }

    // Event handler for clicking the close button
    if (menuclose !== null) {
        menuclose.onclick = function(e) {
            aside.classList.toggle("open");
            header.classList.toggle("open");
            body.classList.toggle("no-scroll");
            html.classList.toggle("no-scroll");
        }
    }

    // Event handler for pressing the Escape key
    document.addEventListener('keydown', function(event) {
        if (event.key === "Escape") {
            event.preventDefault();
            aside.classList.toggle("open");
            header.classList.toggle("open");
            body.classList.toggle("no-scroll");
            html.classList.toggle("no-scroll");
        }
    });

    // Event handler for clicking outside the menu
    document.onclick = function(e) {
        if (e.target.classList.contains('js-menu-close')) {
            aside.classList.toggle("open");
            header.classList.toggle("open");
            body.classList.toggle("no-scroll");
            html.classList.toggle("no-scroll");
        }
    };

    // Event handler for scrolling the page
    document.addEventListener('scroll', function(e) {
        if (window.scrollY > 100) {
            header.classList.add('scroll');
        } else {
            header.classList.remove('scroll');
        }
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide heroSlider
    // *
    // *

    const heroSlider = document.getElementsByClassName('js-hero-slider');
    
    if (heroSlider !== null) {
        for (let i = 0; i < heroSlider.length; i++) {
            new Splide(heroSlider[i], {
                type            : 'fade',
                pauseOnHover    : true,
                rewind          : true,
                lazyLoad        : 'nearby'
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide imageSlider
    // *
    // *

    const imageSlider = document.getElementsByClassName('js-image-slider');
    
    if (imageSlider !== null) {
        for (let i = 0; i < imageSlider.length; i++) {
            new Splide(imageSlider[i], {
                type            : 'fade',
                pauseOnHover    : true,
                rewind          : true,
                lazyLoad        : 'nearby'
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide textSlider
    // *
    // *

    const textSlider = document.getElementsByClassName('js-text-slider');
    
    if (textSlider !== null) {
        for (let i = 0; i < textSlider.length; i++) {
            new Splide(textSlider[i], {
                type            : 'slide',
                rewind          : true,
                arrows          : true,
                pagination      : true,
                lazyLoad        : 'nearby',
                perPage         : 1,
                gap             : '3rem',
                breakpoints: {
                    768: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide instagram
    // *
    // *
    
    // Select the instagramSlider
    const instagramSlider = document.querySelectorAll(".js-instagram-slider");

    // Check if imageSlider were found
    if (instagramSlider !== null) {
        for (let i = 0; i < instagramSlider.length; i++) {
            // splide init
            const splide = new Splide(instagramSlider[i], {
                type            : 'loop',
                rewind          : true,
                autoplay        : true,
                arrows          : false,
                pagination      : false,
                lazyLoad        : 'nearby',
                perPage         : 2,
                perMove         : 1,
                speed           : 1000,
                interval        : 2000,
                gap             : '2rem',
                padding: { left: 0, right: '25%' },
                breakpoints: {
                    768: {
                        perMove : 1,
                        perPage: 2,
                    },
                    576: {
                        perMove : 1,
                        perPage : 1,
                        padding : '30px'
                    },
                }
            }).mount();
        }
    };



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * anchor nav scrollTo
    // *
    // *
    
    // get browser width
    let browserWidth = window.innerWidth;
    let anchorBox = document.querySelector('.js-anchor-nav');
    let anchorBoxSticky = document.querySelector('.js-anchor-sticky');

    // check if anchor modul is set to sticky
    if (anchorBoxSticky !== null) {
        window.addEventListener('scroll', function(e) {
            // get pos from anchorbox
            let pos = Math.round(anchorBox.getBoundingClientRect().y);

            if (pos <= 0) {
                anchorBox.classList.add("stick");
            } else {
                anchorBox.classList.remove("stick");
            }
        });
    }

    // check if anchor modul is set
    if (anchorBox !== null) {
        // needed for sticky anchor to calculate offsetTop
        anchorBoxHeight = anchorBox.offsetHeight;

        if (browserWidth > 1280) {
            anchorBoxHeight = anchorBoxHeight;
        } else {
            anchorBoxHeight = 0;
        }

        const anchors = document.querySelectorAll(".js-scrollTo"); 
        
        for (const anchor of anchors) {
            anchor.addEventListener("click", clickHandler);
        }

        function clickHandler(e) {
            e.preventDefault();
        
            let href = this.getAttribute("href").split("#");
            let newAnchor = "#my" + href[1]
            let offsetTop = document.querySelector(newAnchor).offsetTop - anchorBoxHeight;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal window
    // *
    // *

    let modalWindow = document.querySelector(".js-modal");
    let modalOpen = document.querySelector(".js-modal-btn-open");
    let modalClose = document.querySelector(".js-modal-btn-close");
    
    /* onclick show modal window */
    if (modalOpen !== null) {
        modalOpen.onclick = function() {
            modalWindow.style.display = "block";
            modalClose.focus();
        }
    }
    
    /* close modal window */
    if (modalClose !== null) {
        modalClose.onclick = function() {
            modalWindow.style.display = "none";
        }
    }
    
    /* clicks anywhere outside close modal window */
    window.onclick = function(event) {
        if (event.target == modalWindow) {
            modalWindow.style.display = "none";
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion open every tab
    // *
    // *

    const title = document.querySelectorAll(".js-accordion-title");

    if (title !== null) {
        for (var i=0; i < title.length; i++) {
            title[i].onclick = function(e) {
                this.classList.toggle("open");
                this.nextElementSibling.classList.toggle("open");

                let expanded = this.getAttribute('aria-expanded');
        
                if (expanded == 'false') {
                    this.setAttribute('aria-expanded', 'true')
                } else {
                    this.setAttribute('aria-expanded', 'false')
                }
            }
            
            title[i].addEventListener("keydown", function (event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
        
                    event.preventDefault();
        
                    this.classList.toggle("open");
                    this.nextElementSibling.classList.toggle("open");
        
                    let expanded = this.getAttribute('aria-expanded');
        
                    if (expanded == 'false') {
                        this.setAttribute('aria-expanded', 'true')
                    } else {
                        this.setAttribute('aria-expanded', 'false')
                    }
                }
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hoverAccordion
    // *
    // *

    const accordionItems = document.querySelectorAll('.hoverAccordion__item');
    const windowHeight = window.innerHeight;

    // Check if :hover is supported
    const isHoverSupported = window.matchMedia('(hover: hover)').matches;

    function checkAccordionItems() {
        // Only perform accordion animation if :hover is not supported
        if (!isHoverSupported) {
            const scrollPosition = window.scrollY + (windowHeight / 2);

            accordionItems.forEach(function(item) {
                const itemTop = item.offsetTop;

                if (itemTop <= scrollPosition) {
                    item.classList.add('hoverAccordion__item--default');
                } else {
                    item.classList.remove('hoverAccordion__item--default');
                }
            });
        }
    }

    window.addEventListener('scroll', checkAccordionItems);
    checkAccordionItems();
  
    
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * open external links in new tab
    // *
    // *

    function externalLinks() {
        for(let links = document.getElementsByTagName("a"), number = 0; number < links.length; number++) {
            let currentLink = links[number];
            if(currentLink.getAttribute("href") === "javascript:toggleDrFlexAppointments()"){
                continue;
            }
            // check if link has same hostname. if not add target blank.
            currentLink.getAttribute("href") && currentLink.hostname !== location.hostname && (currentLink.target = "_blank")
        }
    };
    
    externalLinks();




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * simpleParallax
    // *
    // *

    let parallaxImages = document.getElementsByClassName('js-parallax');
    new simpleParallax(parallaxImages, {
        delay: 1,
        scale: 1.25
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * gsap animation
    // *
    // *

    // gsap register plugings
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    ScrollTrigger.normalizeScroll(true);
    // load images with imagesLoaded
    imagesLoaded("#smooth-wrapper", function () {
        // scroll website smoother
        let smoother = ScrollSmoother.create({
            wrapper: "#smooth-wrapper",
            content: "#smooth-content",
            smooth: 1,
            effects: true
        });

        // scroll panels 
        let module = document.querySelector(".js-pinnedSlider");
        let sections = document.querySelectorAll(".js-pinnedSlider-item");
        
        if (sections.length > 0) {
            sections = gsap.utils.toArray(sections);
            
            gsap.to(sections, {
                xPercent: -100 * (sections.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: ".js-pinnedSlider",
                    pin: true,
                    start: "top top",
                    scrub: 1,
                    snap: 1 / (sections.length - 1),
                    end: () => "+=" + (module.scrollWidth - innerWidth),
                }
            });
        }
    });


    // marquee animation
    let marquee = document.querySelectorAll('.marquee__part');

    // added event listener because it doesn't get the right width
    addEventListener("load", function () {
        marquee.forEach(el => {
            // set a default rate, the higher the value, the faster it is
            let rate = 120;
            // get the width of the element
            let distance = window.innerWidth;
            // get the margin-right of the element
            let style = window.getComputedStyle(el);
            let marginRight = parseInt(style.marginRight) || 0;
            // get the total width of the element
            let totalDistance = distance + marginRight;
            // get the duration of the animation 
            // for a better explanation, see the quoted codepen in the first comment
            let time = totalDistance / rate;
            // get the parent of the element
            let container = el.parentElement;

            gsap.to(container, time, {
                repeat: -1,
                x: '-'+totalDistance,
                ease: Linear.easeNone,
            });
        });
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollToTop
    // *
    // *
    
    const scrolltotop  = document.querySelector(".js-scrolltop");

    if (scrolltotop !== null) {
        // show and hide scrollToTop btn on scroll
        document.addEventListener('scroll', function(e) {
            if (window.scrollY > 300) {
                scrolltotop.classList.add("show");
            } else {
                scrolltotop.classList.remove("show");
            }
        });

        // onclick scroll to top
        scrolltotop.onclick = function(e){
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        // onkeydown scroll to top or bottom
        scrolltotop.addEventListener("keydown", function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault();
    
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }   
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollTo
    // *
    // *

    // Select all elements with the class "js-scrollTo"
    const anchors = document.querySelectorAll(".js-scrollTo");

    // Iterate over each anchor element
    for (const anchor of anchors) {
        // Add a click event listener to each anchor
        anchor.addEventListener("click", clickHandler);
    }

    // Function to handle the click event on anchor elements
    function clickHandler(e) {
        e.preventDefault();

        // Get the href attribute value and split it at the "#" symbol
        let href = this.getAttribute("href").split("#");
        
        // Create a new anchor value by adding "my" before the original anchor value
        let newAnchor = "#my" + href[1];
        
        // Get the offsetTop position of the element with the new anchor value
        let offsetTop = document.querySelector(newAnchor).offsetTop;

        // Scroll to the specified offsetTop position with smooth behavior
        scroll({
            top: offsetTop,
            behavior: "smooth"
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash link jump to content
    // *
    // *

    // Add a "load" event listener to the window
    window.addEventListener('load', function () {
        // Get the hash value from the URL
        let getHash = window.location.hash;
        console.log(getHash);
        // Check if an element with the ID "my" + hash value exists
        let elementExists = document.getElementById("my" + getHash.slice(1));
    
        // If the hash value exists and the corresponding element exists
        if (getHash !== null && elementExists !== null) {
            // Create the name of the element by adding "my" before the hash value
            let name = "#my" + getHash.slice(1);
            
            // Get the offsetTop position of the element with the specified name
            let offsetTop = document.querySelector(name).offsetTop;
            // Scroll to the specified offsetTop position with smooth behavior
            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }, false);

});
